import React from 'react';
import { useDispatch } from 'react-redux';

const AlertContainer = {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    position: 'absolute',
    zIndex: '40',
    backgroundColor: '#ffff',
    top: 0,
    left: '20%',
    width: '25rem',
    padding: '1rem',
    borderRadius: '6px',
    border: '1px solid rgb(221, 221, 221)'
}

const Top = {
    display: 'flex'
}

const Icon = {
    color: '#da3849',
    fontSize: '1.3rem',
    margin: 'auto 0',
    marginRight: '0.7rem'
}

const Heading = {
    margin: 0,
    color: '#da3849',
    fontSize: '1.3rem',
}

const Message = {
    fontWeight: 500,
    whiteSpace:' pre-wrap'
}

const ButtonContainer = {
    display: 'flex',
    justifyContent: 'space-between'
}

const Button = {
    border: 'none',
    fontSize: '1rem',
    padding: '0.6rem 1.3rem',
    borderRadius: '6px',
    backgroundColor: '#868E96',
    color: 'white',
    fontWeight: 600,
}

const ConfirmButton = {
    border: 'none',
    fontSize: '1rem',
    padding: '0.6rem 1.3rem',
    borderRadius: '6px',
    color: 'white',
    backgroundColor: '#da3849',
    fontWeight: 700,
}

const Alert = ({ eventId, message, action}) => {
    const dispatch = useDispatch()

    const handleConfirm = () => {
        dispatch(action(true))
        document.querySelector(`.a${eventId}`).classList.add('hide')
        document.querySelector('.admin-background').classList.add('hide')
        document.querySelector('.lang-background').classList.add('hide')
    }

    const handleCancel = () => {
        dispatch(action(false))
        document.querySelector(`.a${eventId}`).classList.add('hide')
        document.querySelector('.admin-background').classList.add('hide')
        document.querySelector('.lang-background').classList.add('hide')
    }
    return (
        <div className={`alert a${eventId} hide`} style={AlertContainer}>
            <div className="tops" style={Top}>
                <i class="fas fa-exclamation-circle" style={Icon}></i>
                <h3 style={Heading}>Alert</h3>
            </div>
            <p style={Message}>{message}</p>

            <div className="button-container" style={ButtonContainer}>
                <button style={Button} onClick={handleCancel}>Cancel</button>
                <button style={ConfirmButton} onClick={handleConfirm}>Confirm</button>
            </div>
        </div>
    )
}

export default Alert